import React from 'react'

import { EnumPriceCalculationType } from '../../../api/Argentia/enums'
import { TankForm } from '../components/tankForm'

export interface TradeSimpleAddPageProps {}

export interface formDependencies {
  id?: number
  code?: string
  description?: string
  precioUnitario?: number
  marketType?: number
  commodity: number
  priceType: number
  redondeo?: number
  relatedFuturePrice?: number | null
  priceExpression?: string
  priceCalculationType?: EnumPriceCalculationType | null
}

export const TanksAddPage: React.FC<any> = props => <TankForm tank={null} />
